export default function BooksSection() {
  const books = [
    {
      title: 'Complete Algebra Mastery',
      subtitle: 'From Basics to Advanced Concepts',
      description: 'Comprehensive guide covering all algebra topics from elementary to college level with hundreds of practice problems and detailed solutions.',
      cover: 'https://public.readdy.ai/ai/img_res/628a443a7656d74245a3ed9d69bf9270.jpg',
      pages: '450 pages',
      level: 'Grade 6-12',
      topics: ['Linear Equations', 'Quadratic Functions', 'Polynomials', 'Systems of Equations']
    },
    {
      title: 'Geometry Fundamentals',
      subtitle: 'Visual Learning Approach',
      description: 'Master geometry through clear diagrams and step-by-step proofs. Perfect for visual learners seeking deep understanding of spatial concepts.',
      cover: 'https://readdy.ai/api/search-image?query=Professional%20mathematics%20textbook%20cover%20design%20for%20geometry%20book%20with%20elegant%20geometric%20shapes%20and%20patterns%20in%20emerald%20green%20and%20gold%20colors%20on%20a%20clean%20white%20background&width=400&height=600&seq=book-cover-002&orientation=portrait',
      pages: '380 pages',
      level: 'Grade 7-10',
      topics: ['Triangles & Angles', 'Circles', 'Area & Volume', 'Coordinate Geometry']
    },
    {
      title: 'SAT Math Preparation Guide',
      subtitle: 'Score 800 with Confidence',
      description: 'Proven strategies and practice tests designed by a master teacher. Includes all question types with detailed explanations and time-saving techniques.',
      cover: 'https://readdy.ai/api/search-image?query=Professional%20test%20preparation%20book%20cover%20design%20for%20SAT%20mathematics%20with%20bold%20typography%20and%20academic%20symbols%20in%20red%20and%20gold%20colors%20on%20a%20clean%20white%20background&width=400&height=600&seq=book-cover-003&orientation=portrait',
      pages: '520 pages',
      level: 'Test Prep',
      topics: ['Heart of Algebra', 'Problem Solving', 'Advanced Math', 'Practice Tests']
    },
    {
      title: 'ACT Math Success',
      subtitle: 'Complete Test Mastery',
      description: 'Everything you need to ace the ACT Math section. Includes full-length practice tests, timing strategies, and expert tips from 30+ years of teaching.',
      cover: 'https://readdy.ai/api/search-image?query=Professional%20test%20preparation%20book%20cover%20design%20for%20ACT%20mathematics%20with%20modern%20typography%20and%20academic%20elements%20in%20purple%20and%20gold%20colors%20on%20a%20clean%20white%20background&width=400&height=600&seq=book-cover-004&orientation=portrait',
      pages: '480 pages',
      level: 'Test Prep',
      topics: ['Pre-Algebra', 'Algebra', 'Geometry', 'Trigonometry']
    },
    {
      title: 'GRE Quantitative Reasoning',
      subtitle: 'Graduate School Success',
      description: 'Advanced mathematics for graduate school entrance. Comprehensive coverage of all GRE math topics with challenging practice problems.',
      cover: 'https://readdy.ai/api/search-image?query=Professional%20test%20preparation%20book%20cover%20design%20for%20GRE%20mathematics%20with%20sophisticated%20typography%20and%20academic%20symbols%20in%20navy%20blue%20and%20gold%20colors%20on%20a%20clean%20white%20background&width=400&height=600&seq=book-cover-005&orientation=portrait',
      pages: '420 pages',
      level: 'Graduate',
      topics: ['Arithmetic', 'Algebra', 'Geometry', 'Data Analysis']
    },
    {
      title: 'GMAT Math Excellence',
      subtitle: 'Business School Preparation',
      description: 'Master GMAT quantitative section with proven strategies. Includes data sufficiency techniques and problem-solving frameworks.',
      cover: 'https://readdy.ai/api/search-image?query=Professional%20test%20preparation%20book%20cover%20design%20for%20GMAT%20mathematics%20with%20executive%20typography%20and%20business%20elements%20in%20charcoal%20gray%20and%20gold%20colors%20on%20a%20clean%20white%20background&width=400&height=600&seq=book-cover-006&orientation=portrait',
      pages: '460 pages',
      level: 'Graduate',
      topics: ['Problem Solving', 'Data Sufficiency', 'Quantitative Reasoning', 'Practice Tests']
    }
  ];

  return (
    <section id="books-section" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 bg-amber-50 px-6 py-3 rounded-full mb-6">
            <i className="ri-book-2-line text-2xl text-amber-600"></i>
            <span className="text-lg font-semibold text-amber-700">Original Publications</span>
          </div>

          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900">
            Mathematics Books by<br />Augustine Anyimadu-Ahenkae
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Exclusive textbooks and test preparation guides written by a master educator with 30+ years of experience. Each book reflects decades of teaching excellence and proven methodologies.
          </p>
        </div>

        {/* Books Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-16">
          {books.map((book, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden group"
            >
              {/* Book Cover */}
              <div className="relative overflow-hidden bg-gray-100 flex items-center justify-center p-8 h-96">
                <div className="w-64 h-80 rounded-lg overflow-hidden shadow-2xl group-hover:scale-105 transition-transform duration-500">
                  <img
                    src={book.cover}
                    alt={book.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Book Info */}
              <div className="p-8">
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-4 py-1 bg-emerald-100 text-emerald-700 text-sm font-semibold rounded-full whitespace-nowrap">
                    {book.level}
                  </span>
                  <span className="text-sm text-gray-600">{book.pages}</span>
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {book.title}
                </h3>
                <p className="text-base text-emerald-600 font-semibold mb-4">
                  {book.subtitle}
                </p>
                <p className="text-sm text-gray-600 leading-relaxed mb-6">
                  {book.description}
                </p>

                {/* Topics */}
                <div className="mb-6">
                  <p className="text-sm font-semibold text-gray-700 mb-3">Key Topics:</p>
                  <div className="flex flex-wrap gap-2">
                    {book.topics.map((topic, tIndex) => (
                      <span
                        key={tIndex}
                        className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full whitespace-nowrap"
                      >
                        {topic}
                      </span>
                    ))}
                  </div>
                </div>

                {/* CTA Button */}
                <button className="w-full py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-semibold rounded-lg hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer">
                  View Book Details
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Info */}
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <i className="ri-book-open-line text-6xl text-amber-600 mb-6"></i>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              All Books Included in Complete Access Membership
            </h3>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Get digital access to all original mathematics books, plus video lessons, worksheets, and personalized support for one low price.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('membership-tiers');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-10 py-5 bg-gradient-to-r from-amber-600 to-orange-600 text-white font-bold text-lg rounded-lg hover:opacity-90 transition-all duration-300 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get Complete Access
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
